export enum SafetyPlanStatus {
  DRAFT = 'draft',
  ACTIVE = 'active',
  EXPIRED = 'expired',
}

export enum SafetyPlanCrisisContactOption {
  LYRA_24_7_LINE = 'lyra_24_7_line',
  NATIONAL_SUICIDE_HOTLINE = 'national_suicide_hotline',
  NATIONAL_DOMESTIC_VIOLENCE_HOTLINE = 'national_domestic_violence_hotline',
  EMERGENCY_911 = 'emergency_911',
  LOCAL_MEDICAL_PROVIDER = 'local_medical_provider',
  LOCAL_EMERGENCY_SERVICES = 'local_emergency_services',
}

export interface SafetyPlanBody {
  warningSigns?: string
  internalCopingStrategies?: string
  crisisContacts?: string
  professionalResources?: string[]
  environmentalSafety?: string
  planBarriers?: string
  additionalNotes?: string
}

export interface SafetyPlan {
  id: string
  patient_id: string
  status: SafetyPlanStatus
  body: SafetyPlanBody | null
  current_version_number: number | null
  activated_date: string | null
  shared_with_client_date: string | null
  client_acknowledged_date: string | null
  expired_date: string | null
  create_date: string
  update_date: string
  draft_body?: SafetyPlanBody | null
  originating_episode_id?: string | null
  created_by_id?: string
  last_modified_by_id?: string
  reviewed_with_client?: boolean | null
  version_id?: number
}
